const internalRoleActionsByRole: Record<string, string[]> = {
  'internal admin': [
    'ReadProducts',
    'WriteProducts',
    'AdminProducts',
    'ReadPackages',
    'WritePackages',
    'AdminPackages',
    'ReadPrintRuns',
    'WritePrintRuns',
    'AdminPrintRuns',
    'ReadTemplates',
    'WriteTemplates',
    'AdminTemplates',
    'ReadCustomLandingPages',
    'WriteCustomLandingPages',
    'AdminCustomLandingPages',
    'ReadBrands',
    'WriteBrands',
    'AdminBrands',
    'ReadFacilities',
    'WriteFacilities',
    'AdminFacilities',
    'ReadImports',
    'WriteImports',
    'AdminImports',
    'ReadUserManagement',
    'WriteUserManagement',
    'AdminUserManagement',
    'AdminInternalMergeQuickstartOrganizations',
    'AdminInternalSuperuserManagement',
    'ReadInternalReports',
    'ReadInternalManualUserVerification',
    'WriteInternalManualUserVerification',
    'WriteInternalUserPasswordReset',
    'ReadInternalPackageSummary',
    'ReadInternalStagedPackageSummary',
    'ReadInternalFacilitySearch',
    'ReadInternalPreviewLayouts',
    'WriteInternalPreviewLayouts',
    'AdminInternalPreviewLayouts',
    'ReadInternalCoaVisibility',
    'WriteInternalCoaVisibility',
    'ReadInternalUserRoles',
    'WriteInternalUserRoles',
    'AdminInternalUserRoles',
    'WriteInternalStagedPackagePromotion',
    'ManageInternalLandingPages',
  ],
  'product owner': [
    'ManageInternalLandingPages',
  ],
  'internal standard': [
    'ReadProducts',
    'WriteProducts',
    'ReadPackages',
    'WritePackages',
    'ReadPrintRuns',
    'WritePrintRuns',
    'ReadTemplates',
    'WriteTemplates',
    'ReadCustomLandingPages',
    'WriteCustomLandingPages',
    'ReadBrands',
    'WriteBrands',
    'ReadFacilities',
    'WriteFacilities',
    'ReadImports',
    'WriteImports',
    'ReadUserManagement',
    'WriteUserManagement',
    'ReadInternalReports',
    'ReadInternalManualUserVerification',
    'WriteInternalManualUserVerification',
    'WriteInternalUserPasswordReset',
    'ReadInternalPackageSummary',
    'ReadInternalStagedPackageSummary',
    'ReadInternalFacilitySearch',
    'ReadInternalPreviewLayouts',
    'WriteInternalPreviewLayouts',
    'WriteInternalStagedPackagePromotion',
  ],
  'internal viewer': [
    'ReadProducts',
    'ReadPackages',
    'ReadPrintRuns',
    'ReadTemplates',
    'ReadCustomLandingPages',
    'ReadBrands',
    'ReadFacilities',
    'ReadImports',
    'ReadUserManagement',
    'ReadInternalReports',
    'ReadInternalManualUserVerification',
    'ReadInternalPackageSummary',
    'ReadInternalStagedPackageSummary',
    'ReadInternalFacilitySearch',
    'ReadInternalPreviewLayouts',
  ],
};

export const internalRoleToPermissionSet = (
  internalRole: string | null | undefined,
  isSuperUser: boolean,
): string[] => {
  if (!isSuperUser) return [];
  const normalizedRole = String(internalRole || '').toLowerCase();
  return internalRoleActionsByRole[normalizedRole] || [];
};
